import { IMakeRequest } from '../../utils/make_request';
import { TURIScheme } from '@cian/http-api/shared/uri';

export interface IErrorInfo {
  error: string;
  isAdblock: boolean;
  bannerType: string;
}

function fixMetric(value: string) {
  return value.replace(/\d+/g, '').replace(/\_/g, '-');
}

const headers: [string, string][] = [
  ['Content-Type', 'application/json'],
];

export function sendLogStatsBanner(makeRequest: IMakeRequest, errorType: string, bannerType: string) {
  makeRequest({
    body: JSON.stringify([{
      name: `adfox.errors.${fixMetric(errorType)}.${fixMetric(bannerType)}`,
      type: 'counter',
      value: '1',
    }]),
    headers,
    method: 'POST',
    uri: {
      host: document.location.host,
      path: '/ajax/stats/',
      scheme: document.location.protocol.slice(0, -1) as TURIScheme,
    },
  }).catch((e) => { throw e; });
}
